import { Component } from "react";

// Keeps a crashing subtree (e.g. a WebGL canvas that loses its context on iPad) from blanking the page.
export class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("ErrorBoundary caught", error);
  }

  render() {
    if (this.state.failed) return this.props.fallback ?? null;
    return this.props.children;
  }
}

export const PageError = () => (
  <main data-testid="page-error" className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
    <p className="font-display text-[34px] text-[#0B2E44]">Something went wrong</p>
    <button type="button" data-testid="page-error-reload" onClick={() => window.location.reload()}
      className="font-ui min-h-[48px] rounded-full border border-[#E8508A] px-6 text-[16px] text-[#B8326C]">Reload</button>
  </main>
);
